import { useMemo } from "react"
import { Outlet } from "react-router-dom"
import PropTypes from "prop-types"
import Modal from "components/modal"
import SecurityProfile from "modules/security-profile"
import FactorProfile from "modules/factor-profile"
import Notifications from "modules/notifications"
import Dialog from "modules/dialog"
import NavRailShell from "connected-components/global-nav-rail/shell"
import LoadingWrapper from "components/loading-wrapper"
import ErrorPage from "components/404"
import { DATA_STATUSES, OK, isLoading } from "helpers/data-statuses"
import saveRecentResources from "hocs/saveRecentResources"
import Nav from "./components/nav"
import Subnav from "./components/subnav"

import "./style.scss"

function WatchlistRoot({
  account,
  watchlist,
  modelId,
  security,
  closeSecurityProfile,
  factorId,
  closeFactorProfile,
  modelStartDate,
  modelEndDate,
  unmodeledDates,
  selectedDate,
  setDate,
  sessionExpired,
  menuItems,
  currency,
  unsupportedCurrencyWarning,
  modelIds,
  setModel,
  selectedModel,
  status,
}) {
  const isResolved = status === OK
  // ERROR is terminal: the name must stop shimmering even though the watchlist never arrives.
  const isPending = isLoading(status)
  const outletContext = useMemo(() => ({
    watchlist,
    modelId,
    modelStartDate,
    selectedDate,
    modelEndDate,
    unmodeledDates,
    setDate,
    currency,
  }), [watchlist, modelId, modelStartDate, selectedDate, modelEndDate, unmodeledDates, setDate, currency])

  return <div className="modules_watchlist-root">
    <Nav account={account} modelId={modelId} watchlistName={watchlist?.name} isLoading={isPending} menuItems={menuItems} />
    <NavRailShell
      searchModelId={modelId}
      // Model controls have nothing to show until they resolve; the empty band holds the row's height.
      subnav={!isResolved ? <div className="watchlist-root-subnav" /> : <Subnav modelId={modelId} modelName={selectedModel.name} setModel={setModel} unsupportedCurrencyWarning={unsupportedCurrencyWarning} modelIds={modelIds} />}
    >
      <div className="main">
        <div className="container-fluid">
          <LoadingWrapper status={[status]} errorComponent={<ErrorPage />}>
            <Outlet context={outletContext} />
          </LoadingWrapper>
        </div>
      </div>
    </NavRailShell>
    <Notifications />
    <Dialog />
    {security && <Modal superModalOpened={sessionExpired} onClose={closeSecurityProfile} className="modules_security-profile" noButton>
      <SecurityProfile security={security} modelId={modelId} onClose={closeSecurityProfile} />
    </Modal>}
    {factorId && <Modal superModalOpened={sessionExpired} onClose={closeFactorProfile} className="modules_factor-profile" noButton>
      <FactorProfile factorId={factorId} modelId={modelId} onClose={closeFactorProfile} />
    </Modal>}
  </div>
}

WatchlistRoot.propTypes = {
  account: PropTypes.string.isRequired,
  watchlist: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  selectedDate: PropTypes.string,
  modelStartDate: PropTypes.string,
  unmodeledDates: PropTypes.object,
  modelEndDate: PropTypes.string,
  setDate: PropTypes.func.isRequired,
  modelId: PropTypes.string,
  security: PropTypes.shape({
    ticker: PropTypes.string,
    exchange: PropTypes.string,
  }),
  closeSecurityProfile: PropTypes.func.isRequired,
  factorId: PropTypes.string,
  closeFactorProfile: PropTypes.func.isRequired,
  setModel: PropTypes.func.isRequired,
  sessionExpired: PropTypes.bool,
  menuItems: PropTypes.array,
  status: PropTypes.oneOf(DATA_STATUSES).isRequired,
  currency: PropTypes.string,
  unsupportedCurrencyWarning: PropTypes.string,
  modelIds: PropTypes.arrayOf(PropTypes.string),
  selectedModel: PropTypes.shape({
    name: PropTypes.string,
  }),
}

export default saveRecentResources(WatchlistRoot, "watchlist.id")
